import { BFFWebChatContextProvider } from '@sa/bff-webchat-ui';
import React from 'react';
import OliviaWebChat from './OliviaWebChat';
import { bffStyleOptions } from './customStyles';

const App = () => (
  <BFFWebChatContextProvider styleOptions={bffStyleOptions}>
    <OliviaWebChat />
  </BFFWebChatContextProvider>
);

export default App;
